import {
  GET_COLORS_FAILURE,
  GET_COLORS_REQUEST,
  GET_COLORS_SUCCESS,
} from "./ActionType";

const initialState = {
  colors: [],
  loading: false,
  error: null,
};

export const colorReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COLORS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_COLORS_SUCCESS:
      return {
        ...state,
        colors: action.payload,
        loading: false,
        error: null,
      };
    case GET_COLORS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
